import { FloatName } from '@src/framework/workbench/drawer/constants';
import LazyBoundary from '@com/LazyBoundary';
import React, { lazy } from 'react';
import { WidgetService, InjectorService } from '@tencent/workbench';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';

const RightSideBar = lazy(() => import(/* webpackChunkName: "lazyComponents" */ '@src/slide/application/service/right-side-bar-service/core/component'));

// 侧边栏接入float组件是过渡方案，现在wb的drawer只支持打开一个，不符合现网的交互规则，待后续支持后，改为接入drawer
export default class RightSideBarFloat {
    private widgetService: WidgetService;
    public constructor() {
        this.widgetService = InjectorService.get(WidgetService);
    }

    public showRightSideBar(): void {
        this.widgetService.float({
            name: FloatName.RIGHT_SIDE_BAR_FLOAT_WIDGET,
            component: <LazyBoundary>
                <RightSideBar getRightSideBarService={this.getRightSideBarService}/>
            </LazyBoundary>,
            // 用于控制组件层级，默认 upper 比 UI 服务组件高，可以设置为 lower，使其可被 UI 服务组件遮挡
            layer: 'middle',
        });
    }

    private getRightSideBarService = (): any => this.getAppServices().viewableServiceLayer.rightSideBarService;

    // 获取AppService
    private getAppServices(): IPcEditorAppServices {
        return AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;
    }
}
